/* tooltip YWC — DEV-17281 — positioned via self-hosted floating-ui */
(function ensure_tooltip_css_once() {
	if (!document.querySelector('.js-yalwa_tip_shared_css')) {
		const link = document.createElement('link');
		link.className = 'js-yalwa_tip_shared_css';
		link.rel = 'stylesheet';
		link.href = yalwa.basics.static_url('css') + 'web_components/tooltip.css';
		document.head.appendChild(link);
	}
})();

const TIP_OPEN_DELAY = 500;
const TIP_CLOSE_DELAY = 500;
const TIP_GAP_PX = 12;

// Single document-level scroll listener — checks the singleton tip_current
// rather than each instance binding its own. One listener for ALL tooltip
// instances; the module-level tip_current reference is always the last-opened
// or opening-delay-pending instance (set in schedule_open).
document.addEventListener('scroll', function () {
	if (tip_current) {
		tip_current.dismiss_immediate();
	}
}, true);
const TIP_ARROW_PERP_PX = 16;
const TIP_ARROW_EDGE_INSET = 4;

const TIP_ALIGNMENT_MAP = {
	bottomCenter: 'bottom',
	bottomLeft:   'bottom-start',
	bottomRight:  'bottom-end',
	topCenter:    'top',
	topLeft:      'top-start',
	topRight:     'top-end',
	leftCenter:   'left',
	leftTop:      'left-start',
	leftBottom:   'left-end',
	rightCenter:  'right',
	rightTop:     'right-start',
	rightBottom:  'right-end',
	auto:         'bottom'
};

const TIP_SIDES = ['top', 'right', 'bottom', 'left'];

let tip_current = null;
let float_ui_load_promise = null;

function ensure_floating_ui() {
	if (float_ui_load_promise) {
		return float_ui_load_promise;
	}
	float_ui_load_promise = new Promise(function (resolve) {
		const s = document.createElement('script');
		s.src = yalwa.basics.static_url('js') + 'external/floating-ui/floating-ui.umd.min.js';
		s.onload = function () {
			resolve(window.FloatingUIDOM);
		};
		s.onerror = function () {
			resolve(null);
		};
		document.head.appendChild(s);
	});
	return float_ui_load_promise;
}

function tip_resolve_placement(host_value) {
	const key = host_value || 'bottomCenter';
	return TIP_ALIGNMENT_MAP[key] || 'bottom';
}

function tip_is_auto(host_value) {
	return (host_value || 'bottomCenter') === 'auto';
}

function tip_side_of(placement) {
	return placement.split('-')[0];
}


class YalwaTip extends HTMLElement {

	static get observedAttributes() {
		return ['content', 'alignment', 'truncate', 'inverse', 'for'];
	}

	constructor() {
		super();
		this.state = 'idle';
		this.timer = null;
		this.bubble = null;
		this.arrow = null;
		this.cleanup_pos = null;
		this.target = null;
		this.title_backup = null;
		this.bound = {};
		this.pending_open = false;
	}

	connectedCallback() {
		this.resolve_target();
		this.bind_events();
	}

	disconnectedCallback() {
		this.unbind_events();
		this.dismiss_immediate();
		this.destroy_bubble();
	}

	attributeChangedCallback(name, old_value, new_value) {
		if (old_value === new_value) {
			return;
		}
		if (name === 'for') {
			this.unbind_events();
			this.resolve_target();
			this.bind_events();
			return;
		}
		if (!this.bubble) {
			return;
		}
		if (name === 'content') {
			const content_el = this.bubble.querySelector('.yalwa_tip__content');
			if (content_el) {
				content_el.textContent = new_value || '';
			}
		} else if (name === 'truncate') {
			this.bubble.setAttribute('truncate', new_value || 'false');
		} else if (name === 'inverse') {
			this.bubble.setAttribute('inverse', new_value || 'false');
		} else if (name === 'alignment') {
			this.update_position();
		}
	}

	resolve_target() {
		const for_id = this.getAttribute('for');
		if (for_id) {
			this.target = document.getElementById(for_id);
			return;
		}
		let node = this.firstChild;
		while (node) {
			if (node.nodeType === Node.ELEMENT_NODE) {
				this.target = node;
				return;
			}
			node = node.nextSibling;
		}
		this.target = null;
	}

	bind_events() {
		if (!this.target) {
			return;
		}
		this.bound.enter = this.on_enter.bind(this);
		this.bound.leave = this.on_leave.bind(this);
		this.bound.focus = this.on_focus.bind(this);
		this.bound.blur = this.on_blur.bind(this);
		this.bound.deny_click = this.on_trigger_click.bind(this);
		this.target.addEventListener('mouseenter', this.bound.enter);
		this.target.addEventListener('mouseleave', this.bound.leave);
		this.target.addEventListener('focusin',  this.bound.focus);
		this.target.addEventListener('focusout', this.bound.blur);
		this.target.addEventListener('click',   this.bound.deny_click);
	}

	unbind_events() {
		if (this.target) {
			this.target.removeEventListener('mouseenter', this.bound.enter);
			this.target.removeEventListener('mouseleave', this.bound.leave);
			this.target.removeEventListener('focusin',  this.bound.focus);
			this.target.removeEventListener('focusout', this.bound.blur);
			this.target.removeEventListener('click',   this.bound.deny_click);
		}

	}

	on_enter() {
		this.schedule_open(false);
	}

	on_leave() {
		this.schedule_close(false);
	}

	on_focus() {
		this.schedule_open(true);
	}

	on_blur() {
		this.schedule_close(true);
	}

	on_trigger_click() {
		this.schedule_close(true);
	}

	schedule_open(immediate) {
		// Singleton: dismiss any previously scheduled OR shown tooltip before scheduling me.
		// `tip_current` covers both 'opening' (pending-delay) and 'open' states so rapid hover
		// across many triggers never leaves multiple pending timers alive at once.
		if (tip_current && tip_current !== this) {
			tip_current.dismiss_immediate();
		}
		tip_current = this;
		this.clear_timer();
		this.pending_open = true;
		if (immediate) {
			this.open();
			return;
		}
		this.state = 'opening';
		const self = this;
		this.timer = setTimeout(function () {
			self.open();
		}, TIP_OPEN_DELAY);
	}

	schedule_close(immediate) {
		this.pending_open = false;
		this.clear_timer();
		if (this.state === 'idle') {
			return;
		}
		if (immediate) {
			this.close();
			return;
		}
		this.state = 'closing';
		const self = this;
		this.timer = setTimeout(function () {
			self.close();
		}, TIP_CLOSE_DELAY);
	}

	async open() {
		this.pending_open = false;
		if (this.state === 'open') {
			return;
		}
		if (!this.has_content()) {
			this.state = 'idle';
			if (tip_current === this) {
				tip_current = null;
			}
			return;
		}
		this.ensure_bubble();
		this.sync_bubble_attrs();
		const floating = await ensure_floating_ui();
		// If close() or dismiss_immediate() fired while we were waiting for the
		// floating-ui script to load, the state has already been reset — don't
		// overwrite it back to 'open' and create a zombie tooltip.
		if (this.state !== 'opening') {
			return;
		}
		// If floating-ui failed to load, bail silently (the title fallback still works).
		if (!floating) {
			return;
		}
		this.state = 'open';
		this.do_position(floating);
		tip_current = this;
		this.suppress_title();
	}

	close() {
		// Hide the bubble + tear down positioning for any non-idle state. The earlier
		// `if (state !== 'open') return` short-circuit silently skipped hiding when
		// close() was reached via the schedule_close(false) -> setTimeout path (state
		// was 'closing' by the time the timer fired), leaving an .is_visible bubble on screen.
		if (this.state === 'idle') {
			return;
		}
		if (this.bubble) {
			this.bubble.classList.remove('is_visible');
		}
		this.stop_positioning();
		this.restore_title();
		if (tip_current === this) {
			tip_current = null;
		}
		this.state = 'idle';
	}

	clear_timer() {
		if (this.timer) {
			clearTimeout(this.timer);
			this.timer = null;
		}
	}

	dismiss_immediate() {
		// Force-hide even when state is 'opening' or 'closing' — `close()` short-circuits
		// in those states and would otherwise leave an .is_visible bubble on screen.
		this.pending_open = false;
		this.clear_timer();
		if (this.bubble) {
			this.bubble.classList.remove('is_visible');
		}
		this.stop_positioning();
		this.restore_title();
		if (tip_current === this) {
			tip_current = null;
		}
		this.state = 'idle';
	}

	has_content() {
		const content = this.getAttribute('content');
		return !!(content && content.trim());
	}

	ensure_bubble() {
		if (this.bubble) {
			return;
		}
		this.bubble = document.createElement('div');
		this.bubble.className = 'yalwa_tip__bubble';
		this.bubble.setAttribute('role', 'tooltip');
		this.bubble.setAttribute('aria-hidden', 'true');
		const content_el = document.createElement('span');
		content_el.className = 'yalwa_tip__content';
		this.bubble.appendChild(content_el);
		this.arrow = document.createElement('span');
		this.arrow.className = 'yalwa_tip__arrow';
		this.arrow.setAttribute('aria-hidden', 'true');
		this.bubble.appendChild(this.arrow);
		document.body.appendChild(this.bubble);
	}

	sync_bubble_attrs() {
		if (!this.bubble) {
			return;
		}
		const content_el = this.bubble.querySelector('.yalwa_tip__content');
		if (content_el) {
			content_el.textContent = this.getAttribute('content') || '';
		}
		this.bubble.setAttribute('truncate', this.getAttribute('truncate') || 'false');
		this.bubble.setAttribute('inverse',  this.getAttribute('inverse')  || 'false');
		this.bubble.setAttribute('aria-hidden', 'false');
	}

	suppress_title() {
		if (this.title_backup !== null) {
			return;
		}
		const title = this.getAttribute('title');
		if (title) {
			this.title_backup = title;
			this.removeAttribute('title');
		} else {
			this.title_backup = '';
		}
	}

	restore_title() {
		if (this.title_backup === null) {
			return;
		}
		if (this.title_backup) {
			this.setAttribute('title', this.title_backup);
		}
		this.title_backup = null;
		if (this.bubble) {
			this.bubble.setAttribute('aria-hidden', 'true');
		}
	}

	stop_positioning() {
		if (this.cleanup_pos) {
			this.cleanup_pos();
			this.cleanup_pos = null;
		}
	}

	destroy_bubble() {
		this.stop_positioning();
		if (this.bubble && this.bubble.parentNode) {
			this.bubble.parentNode.removeChild(this.bubble);
		}
		this.bubble = null;
		this.arrow = null;
	}

	build_middleware(floating) {
		const alignment_value = this.getAttribute('alignment');
		const middleware = [floating.offset(TIP_GAP_PX)];
		if (tip_is_auto(alignment_value)) {
			middleware.push(floating.autoPlacement());
		} else {
			middleware.push(floating.flip());
		}
		middleware.push(floating.shift({padding: 8}));
		if (this.arrow) {
			middleware.push(floating.arrow({element: this.arrow}));
		}
		return middleware;
	}

	do_position(floating) {
		if (!floating || !this.bubble || !this.target || this.state !== 'open') {
			return;
		}
		const self = this;
		const alignment_value = this.getAttribute('alignment');
		const placement = tip_resolve_placement(alignment_value);
		const middleware = this.build_middleware(floating);
		if (this.cleanup_pos) {
			this.cleanup_pos();
		}
		this.cleanup_pos = floating.autoUpdate(this.target, this.bubble, function () {
			self.update_position(floating, placement, middleware);
		});
		self.update_position(floating, placement, middleware);
	}

	update_position(floating, placement, middleware) {
		if (!floating) {
			floating = window.FloatingUIDOM;
		}
		if (!floating || !this.bubble || !this.target || this.state !== 'open') {
			return;
		}
		if (!placement) {
			placement = tip_resolve_placement(this.getAttribute('alignment'));
		}
		if (!middleware) {
			middleware = this.build_middleware(floating);
		}
		const self = this;
		floating.computePosition(this.target, this.bubble, {
			placement: placement,
			middleware: middleware
		}).then(function (data) {
			self.apply_position(data);
		}).catch(function () {});
	}

	apply_position(data) {
		if (!this.bubble) {
			return;
		}
		const style = this.bubble.style;
		style.left = '0';
		style.top = '0';
		style.transform = `translate(${Math.round(data.x)}px, ${Math.round(data.y)}px)`;
		this.bubble.classList.add('is_visible');
		this.bubble.setAttribute('data-placement', data.placement);
		if (!this.arrow || !data.middlewareData || !data.middlewareData.arrow) {
			return;
		}
		const arrow_data = data.middlewareData.arrow;
		const side = tip_side_of(data.placement);
		const arrow_style = this.arrow.style;
		// Perpendicular positioning is set by us (push arrow outside the bubble edge).
		// floating-ui only sets the aligned-axis offset (left for top/bottom placements,
		// top for left/right placements).
		arrow_style.left = '';
		arrow_style.top = '';
		arrow_style.right = '';
		arrow_style.bottom = '';
				// Parallel axis: for -start/-end alignments, pin the arrow to the
		// corresponding bubble edge rather than floating-ui's trigger-centre.
		// (floating-ui's arrow middleware always targets the reference centre;
		// this override makes the arrow visually match the Figma spec for
		// edge-aligned placements.)
		const alignment = data.placement.includes('-start') ? 'start' :
		                  data.placement.includes('-end')   ? 'end'   : 'center';
		if (alignment === 'start') {
			if (arrow_data.x != null) {
				arrow_style.left = `${TIP_ARROW_EDGE_INSET}px`;
			} else if (arrow_data.y != null) {
				arrow_style.top = `${TIP_ARROW_EDGE_INSET}px`;
			}
		} else if (alignment === 'end') {
			if (arrow_data.x != null) {
				arrow_style.right = `${TIP_ARROW_EDGE_INSET}px`;
				arrow_style.left = 'auto';
			} else if (arrow_data.y != null) {
				arrow_style.bottom = `${TIP_ARROW_EDGE_INSET}px`;
				arrow_style.top = 'auto';
			}
		} else {
			if (arrow_data.x != null) {
				arrow_style.left = `${Math.round(arrow_data.x)}px`;
			}
			if (arrow_data.y != null) {
				arrow_style.top = `${Math.round(arrow_data.y)}px`;
			}
		}
		let perp_prop = '';
		if (side === 'bottom') {
			perp_prop = 'top';
		} else if (side === 'top') {
			perp_prop = 'bottom';
		} else if (side === 'left') {
			perp_prop = 'right';
		} else if (side === 'right') {
			perp_prop = 'left';
		}
		if (perp_prop) {
			// Half the arrow's perpendicular dimension pokes out toward the trigger;
			// the other half stays inside the bubble (the bubble is opaque, so the
			// inner half is visually invisible but the base now sits flush against
			// the bubble's edge — no seam, no protruding-out-of-rectangle glitch.
			arrow_style[perp_prop] = `-${Math.round(TIP_ARROW_PERP_PX / 2)}px`;
		}
		this.arrow.setAttribute('data-side', side);
	}
}

customElements.define('yalwa-tip', YalwaTip);